import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Bookmark = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="bookmark icon"
    className={`h-${size} w-${size} ${className}`}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 3C5.72386 3 5.5 3.22386 5.5 3.5V20.6943L12 15.0068L18.5 20.6943V3.5C18.5 3.22386 18.2761 3 18 3H6ZM2.5 3.5C2.5 1.567 4.067 0 6 0H18C19.933 0 21.5 1.567 21.5 3.5V21.7962C21.5 23.9441 18.9702 25.0921 17.3537 23.6777L12 18.9932L6.64626 23.6777C5.02981 25.0921 2.5 23.9441 2.5 21.7962V3.5Z"
    />
  </svg>
)
